import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(private http: HttpClient) {}

  getGoogleMapsApiKey(): Observable<string> {
    return this.http.get<string>('/dashboard/google_map_api_key/'); // Example API endpoint
  }
}
